import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import useEmbedTokenRefresh from '../hooks/useEmbedTokenRefresh';

const ReportWrapper = styled.div`
  width: 100%;
  height: 100%;

  .analytics-report,
  .analytics-report iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const PowerBIReport = ({
  embedUrl,
  embedToken,
  reportId,
  serviceLine,
  tokenExpiry = null,
}) => {
  const { setReport, eventHandlers } = useEmbedTokenRefresh(
    serviceLine,
    tokenExpiry,
  );

  return (
    <ReportWrapper>
      <PowerBIEmbed
        // Keep the values here stable: PowerBIEmbed deep-compares this config on
        // every update and re-embeds the whole report when it differs. Token
        // renewal goes through the report instance instead — see
        // useEmbedTokenRefresh.
        embedConfig={{
          type: 'report',
          id: reportId,
          embedUrl,
          accessToken: embedToken,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: true, expanded: false },
              pageNavigation: { visible: false },
            },
          },
        }}
        cssClassName="analytics-report"
        getEmbeddedComponent={setReport}
        eventHandlers={eventHandlers}
      />
    </ReportWrapper>
  );
};

PowerBIReport.propTypes = {
  embedUrl: PropTypes.string.isRequired,
  embedToken: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired,
  serviceLine: PropTypes.string.isRequired,
  tokenExpiry: PropTypes.string,
};

export default PowerBIReport;
